export var ProductType;
(function (ProductType) {
    ProductType["DIGITAL"] = "digital";
    ProductType["PHYSICAL"] = "physical";
})(ProductType || (ProductType = {}));
export var MediaFrameMediaType;
(function (MediaFrameMediaType) {
    MediaFrameMediaType["SECURE_PICTURE"] = "secure_picture";
    MediaFrameMediaType["SECURE_VIDEO"] = "secure_video";
    MediaFrameMediaType["SECURE_DOCUMENT"] = "secure_document";
    MediaFrameMediaType["SECURE_MUSIC"] = "secure_music";
    MediaFrameMediaType["SECURE_ARCHIVE"] = "secure_archive";
})(MediaFrameMediaType || (MediaFrameMediaType = {}));
export var FilterType;
(function (FilterType) {
    FilterType["CATEGORY"] = "CATEGORY";
    FilterType["FILTERED_CATEGORIES"] = "FILTERED_CATEGORIES";
    FilterType["PRICE"] = "PRICE";
    FilterType["COLOR"] = "OPTION_COLOR";
    FilterType["LIST"] = "OPTION_LIST";
})(FilterType || (FilterType = {}));
export var FilterConfigType;
(function (FilterConfigType) {
    FilterConfigType["CATEGORY"] = "CATEGORY";
    FilterConfigType["PRICE"] = "PRICE";
    FilterConfigType["OPTIONS"] = "OPTIONS";
    FilterConfigType["OPTION_LIST"] = "OPTION_LIST";
})(FilterConfigType || (FilterConfigType = {}));
export var ImageModeId;
(function (ImageModeId) {
    ImageModeId[ImageModeId["Crop"] = 1] = "Crop";
    ImageModeId[ImageModeId["Fit"] = 2] = "Fit";
})(ImageModeId || (ImageModeId = {}));
export var HoverType;
(function (HoverType) {
    HoverType["None"] = "none";
    HoverType["Zoom"] = "zoom";
    HoverType["Border"] = "border";
    HoverType["Alternate"] = "alternate";
})(HoverType || (HoverType = {}));
export var ImageRatioId;
(function (ImageRatioId) {
    ImageRatioId[ImageRatioId["_3x2"] = 0] = "_3x2";
    ImageRatioId[ImageRatioId["_4x3"] = 1] = "_4x3";
    ImageRatioId[ImageRatioId["_1x1"] = 2] = "_1x1";
    ImageRatioId[ImageRatioId["_3x4"] = 3] = "_3x4";
    ImageRatioId[ImageRatioId["_2x3"] = 4] = "_2x3";
    ImageRatioId[ImageRatioId["_16x9"] = 5] = "_16x9";
    ImageRatioId[ImageRatioId["_9x16"] = 6] = "_9x16";
})(ImageRatioId || (ImageRatioId = {}));
//# sourceMappingURL=galleryDef.js.map